import { Tracking } from './Tracking';

export class XPromoTracking {
    public static xPromoShow(gameName: string) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'xPromo_Show',
            valueToSum: 1,
            params: {
                target: gameName,
            },
        });
    }
    public static xPromoAccept(gameName: string) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'xPromo_Accept',
            valueToSum: 1,
            params: {
                target: gameName,
            },
        });
    }
    public static xPromoClose(gameName: string) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'xPromo_Close',
            valueToSum: 1,
            params: {
                target: gameName,
            },
        });
    }
    public static xPromoConfirm(gameName: string) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'xPromo_Confirm',
            valueToSum: 1,
            params: {
                target: gameName,
            },
        });
    }
    public static xPromoDeny(gameName: string) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'xPromo_Deny',
            valueToSum: 1,
            params: {
                target: gameName,
            },
        });
    }
}
